import { axiosInstance } from "../../utils";

const actions = {
  FETCH_BLOGS_REQUESTED: "FETCH_BLOGS_REQUESTED",
  FETCH_BLOGS_SUCCEEDED: "FETCH_BLOGS_SUCCEEDED",
  FETCH_BLOGS_FAILED: "FETCH_BLOGS_FAILED",

  FETCH_BLOG_REQUESTED: "FETCH_BLOG_REQUESTED",
  FETCH_BLOG_SUCCEEDED: "FETCH_BLOG_SUCCEEDED",
  FETCH_BLOG_FAILED: "FETCH_BLOG_FAILED",

  DELETE_BLOG_REQUESTED: "DELETE_BLOG_REQUESTED",
  DELETE_BLOG_SUCCEEDED: "DELETE_BLOG_SUCCEEDED",
  DELETE_BLOG_FAILED: "DELETE_BLOG_FAILED",

  CLEAR_BLOG: "CLEAR_BLOG",

  removeBlog: (id = undefined) => {
    return {
      type: actions.DELETE_BLOG_REQUESTED,
      payload: id,
    };
  },

  deleteBlog: async (id = undefined) => {
    const url = `blogs/` + id;

    try {
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchBlogs: (params = undefined) => {
    return {
      type: actions.FETCH_BLOGS_REQUESTED,
      payload: params,
    };
  },

  fetchBlog: (id = undefined) => {
    return {
      type: actions.FETCH_BLOG_REQUESTED,
      payload: id,
    };
  },

  getBlogs: async (params = undefined) => {
    const url = `blogs`;

    try {
      const blogs = await axiosInstance.get(url, { params });
      return blogs.data;
    } catch (error) {
      throw error;
    }
  },

  getBlog: async (blogId = undefined) => {
    const url = `blogs/` + blogId;

    try {
      const blog = await axiosInstance.get(url);
      return blog.data;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
